import { AuthScreensGallery } from "@/features/auth/screens/AuthScreensGallery";
import { useNav } from "@/utils/nav";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const AuthScreensSearchZ = z.object({
    group: z.string().optional(),
    screen: z.string().optional(),
});

export const Route = createFileRoute("/_app/design/components/auth")({
    component: AuthScreensPage,
    validateSearch: (search) => AuthScreensSearchZ.parse(search),
});

function AuthScreensPage() {
    useNav([
        { label: "Design", route: { to: "/design" } },
        { label: "Auth screens", route: { to: "/design/components/auth" } },
    ]);
    const { group, screen } = Route.useSearch();
    const navigate = Route.useNavigate();

    return (
        <AuthScreensGallery
            group={group}
            screen={screen}
            onScreenChange={(next) => void navigate({ search: (prev) => ({ ...prev, screen: next }), replace: true })}
        />
    );
}
